import BookmarkPanel from './BookmarkPanel';
import './BookmarkPanel.scss';

export default BookmarkPanel;
